import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../interface_user/header/header";
import Footer from "../interface_user/footer/footer";
import Footer1 from "../interface_user/footer/footer1";
import axios from "axios";
import { jwtDecode } from 'jwt-decode';
import {
  CheckOutlined,
  ClockCircleOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  PlusOutlined,
  FileTextOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
  DollarOutlined,
  TeamOutlined,
  GlobalOutlined
} from "@ant-design/icons";
import { baseApiUrl } from "../../services/api";
import {
  Table,
  Modal,
  Button,
  notification,
  Input,
  Switch,
  Card,
  Row,
  Col,
  Tag,
  Avatar,
  Divider,
  Steps,
  Form,
  Select,
  Upload,
  Tooltip
} from "antd";

const { Step } = Steps;
const { TextArea } = Input;
const { Option } = Select;

function DetailPublications() {
  const [utilisateur, setUtilisateur] = useState(null);
  const [titre, setTitre] = useState("");
  const [description, setDescription] = useState("");
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [publications, setPublications] = useState([]);
  const [document, setDocument] = useState(null);
  const [image, setImage] = useState("");
  const [zoneExecution, setZoneExecution] = useState(null);
  const [impactEconomique, setImpactEconomique] = useState(null);
  const [impactSocial, setImpactSocial] = useState(null);
  const [impactEnvironnemental, setImpactEnvironnemental] = useState(null);
  const [selectedCategorie, setSelectedCategorie] = useState(null);
  const [video, setVideo] = useState("");
  const [calendrierFin, setCalendrierFin] = useState("");
  const [calendrierDebut, setCalendrierDebut] = useState("");
  const [step, setStep] = useState(0);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingPublications, setEditingPublications] = useState(null);
  const [viewingPublications, setViewingPublications] = useState(null);
  const [form] = Form.useForm();

  const { profileId } = useParams();
  const [currentUser, setCurrentUser] = useState(null);

  // Récupérer les publications de l'utilisateur connecté
  const fetchPublications = async () => {
    if (!currentUser?.id) {
      console.warn("Utilisateur connecté introuvable, impossible de filtrer les publications.");
      return;
    }

    try {
      const response = await baseApiUrl.get("/publication/liste");
      console.log("Données reçues des publications :", response.data);

      const allPublications = Array.isArray(response.data) ? response.data : [];

      // Filtrer les publications en fonction de l'utilisateur connecté
      const userPublications = allPublications.filter(
        (pub) => pub.utilisateur?.id === currentUser.id
      );

      setPublications(userPublications);
      console.log("Publications de l'utilisateur connecté :", userPublications);
    } catch (error) {
      console.error("Erreur lors de la récupération des publications de l'utilisateur :", error);
    }
  };

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  const handleEdit = (publication) => {
    setViewingPublications(publication);
    setEditingPublications(publication);

    form.setFieldsValue({
      titre: publication.titre,
      description: publication.description,
      zoneExecution: publication.zoneExecution,
      impactEconomique: publication.impactEconomique,
      impactSocial: publication.impactSocial,
      impactEnvironnemental: publication.impactEnvironnemental,
      selectedCategorie: publication.categorieId,
      calendrierDebut: publication.calendrierDebut,
      calendrierFin: publication.calendrierFin,
    });

    setIsEditMode(true);
    setIsEditModalVisible(true);
    setStep(0);
  };

  const handleDeleteConfirm = (publication) => {
    Modal.confirm({
      title: 'Êtes-vous sûr de vouloir supprimer cette publication ?',
      content: 'Cette action est irréversible.',
      okText: 'Oui, supprimer',
      cancelText: 'Annuler',
      onOk: () => handleDelete(publication.id),
    });
  };

  const handleDelete = async (publicationId) => {
    try {
      await baseApiUrl.delete(`/publication/delete/${publicationId}`);
      setPublications(publications.filter(pub => pub.id !== publicationId));
      openNotificationWithIcon("success", "Publication supprimée avec succès.");
    } catch (error) {
      console.error("Erreur lors de la suppression de la publication:", error);
      openNotificationWithIcon("error", "Erreur lors de la suppression de la publication.");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded);
        console.log("Utilisateur connecté:", decoded);
      } catch (error) {
        console.error("Erreur lors du décodage du token:", error);
      }
    } else {
      console.warn("Aucun token trouvé dans localStorage.");
    }
  }, []);

  const handleNext = () => {
    setStep(step + 1);
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };

  const handleEditPublication = async (values) => {
    if (!editingPublications) {
      openNotificationWithIcon("error", "Aucune publication sélectionnée pour la modification.");
      return;
    }

    const publicationData = {
      titre: values.titre,
      description: values.description,
      categorieId: values.selectedCategorie,
      zoneExecution: values.zoneExecution,
      impactEconomique: values.impactEconomique,
      impactEnvironnemental: values.impactEnvironnemental,
      impactSocial: values.impactSocial,
    };

    const formData = new FormData();
    formData.append("publication", new Blob([JSON.stringify(publicationData)], { type: "application/json" }));

    if (image) formData.append("image", image);
    if (document) formData.append("document", document);

    try {
      const response = await baseApiUrl.put(`/publication/update/${editingPublications.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const updatedPublication = await response.data;
      console.log("Publication mise à jour:", updatedPublication);

      setPublications(
        publications.map((pub) => (pub.id === updatedPublication.id ? updatedPublication : pub))
      );

      openNotificationWithIcon("success", "Publication modifiée avec succès.");
      fetchPublications();
    } catch (error) {
      console.error("Erreur lors de la modification de la publication:", error);
      openNotificationWithIcon("error", "Erreur lors de la modification de la publication.");
    }

    resetForm();
  };

  const truncateText = (text, wordLimit) => {
    if (typeof text !== "undefined" && text !== null) {
      const words = text.split(" ");
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(" ") + "...";
      }
      return text;
    } else {
      return "";
    }
  };

  const resetForm = () => {
    setStep(0);
    setIsEditMode(false);
    setEditingPublications(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
    form.resetFields();
    setImage("");
    setDocument("");
  };

  const handleView = (publication) => {
    setViewingPublications(publication);
    setIsViewModalVisible(true);
    setStep(0);
  };

  useEffect(() => {
    if (profileId) {
      baseApiUrl
        .get(`/utilisateur/${profileId}`)
        .then((response) => {
          setUtilisateur(response.data);
          console.log("Utilisateur récupéré :", response.data);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération de l'utilisateur :", error);
        });
    } else {
      console.error("L'ID du profil est introuvable !");
    }

    if (currentUser) {
      fetchPublications();
    }
  }, [profileId, currentUser]);

  useEffect(() => {
    if (currentUser) {
      fetchPublications();
    }
  }, [currentUser]);

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      width: 80,
      render: (imageName) => {
        const imageUrl = baseApiUrl.defaults.baseURL + `/image/${imageName}`;
        return (
          <Avatar
            size={50}
            src={imageUrl}
            icon={<FileTextOutlined />}
            style={{ borderRadius: '8px' }}
          />
        );
      },
    },
    {
      title: "Titre",
      dataIndex: "titre",
      key: "titre",
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: 'bold', color: '#1890ff' }}>
            {truncateText(text, 4)}
          </div>
          <div style={{ fontSize: '12px', color: '#666' }}>
            {new Date(record.created).toLocaleDateString()}
          </div>
        </div>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (
        <div style={{ maxWidth: '200px' }}>
          {truncateText(text, 8)}
        </div>
      ),
    },
    {
      title: "Statut",
      dataIndex: "actif",
      key: "actif",
      render: (actif) =>
        actif ? (
          <Tag color="success" icon={<CheckOutlined />}>
            Validé
          </Tag>
        ) : (
          <Tag color="warning" icon={<ClockCircleOutlined />}>
            En attente
          </Tag>
        ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 160,
      render: (text, record) => (
        <div style={{ display: 'flex', gap: '4px' }}>
          <Tooltip title="Voir les détails">
            <Button
              type="primary"
              size="small"
              icon={<EyeOutlined />}
              onClick={() => {
                resetForm();
                handleView(record);
              }}
            />
          </Tooltip>

          {!record.actif && (
            <>
              <Tooltip title="Modifier">
                <Button
                  type="default"
                  size="small"
                  icon={<EditOutlined />}
                  onClick={() => {
                    resetForm();
                    handleEdit(record);
                  }}
                />
              </Tooltip>
              <Tooltip title="Supprimer">
                <Button
                  type="default"
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => handleDeleteConfirm(record)}
                />
              </Tooltip>
            </>
          )}
        </div>
      ),
    },
  ];

  const renderStepContent = (currentStep, isViewMode = false) => {
    const data = isViewMode ? viewingPublications : null;

    switch (currentStep) {
      case 0:
        return (
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Card size="small" style={{ height: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                  <FileTextOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                  <strong>Titre</strong>
                </div>
                {isViewMode ? (
                  <p>{data?.titre}</p>
                ) : (
                  <Form.Item name="titre" rules={[{ required: true, message: 'Titre requis' }]}>
                    <Input placeholder="Titre de la publication" />
                  </Form.Item>
                )}
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card size="small" style={{ height: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                  <EnvironmentOutlined style={{ marginRight: 8, color: '#52c41a' }} />
                  <strong>Zone d'exécution</strong>
                </div>
                {isViewMode ? (
                  <p>{data?.zoneExecution}</p>
                ) : (
                  <Form.Item name="zoneExecution">
                    <TextArea rows={3} placeholder="Zone d'exécution" />
                  </Form.Item>
                )}
              </Card>
            </Col>
            <Col xs={24}>
              <Card size="small">
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                  <FileTextOutlined style={{ marginRight: 8, color: '#722ed1' }} />
                  <strong>Description</strong>
                </div>
                {isViewMode ? (
                  <p>{data?.description}</p>
                ) : (
                  <Form.Item name="description">
                    <TextArea rows={4} placeholder="Description de la publication" />
                  </Form.Item>
                )}
              </Card>
            </Col>
          </Row>
        );

      case 1:
        return (
          <Row gutter={[16, 16]}>
            <Col xs={24} md={8}>
              <Card size="small" style={{ height: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                  <DollarOutlined style={{ marginRight: 8, color: '#faad14' }} />
                  <strong>Impact Économique</strong>
                </div>
                {isViewMode ? (
                  <p>{data?.impactEconomique}</p>
                ) : (
                  <Form.Item name="impactEconomique">
                    <TextArea rows={3} placeholder="Impact économique" />
                  </Form.Item>
                )}
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card size="small" style={{ height: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                  <TeamOutlined style={{ marginRight: 8, color: '#f5222d' }} />
                  <strong>Impact Social</strong>
                </div>
                {isViewMode ? (
                  <p>{data?.impactSocial}</p>
                ) : (
                  <Form.Item name="impactSocial">
                    <TextArea rows={3} placeholder="Impact social" />
                  </Form.Item>
                )}
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card size="small" style={{ height: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                  <GlobalOutlined style={{ marginRight: 8, color: '#52c41a' }} />
                  <strong>Impact Environnemental</strong>
                </div>
                {isViewMode ? (
                  <p>{data?.impactEnvironnemental}</p>
                ) : (
                  <Form.Item name="impactEnvironnemental">
                    <TextArea rows={3} placeholder="Impact environnemental" />
                  </Form.Item>
                )}
              </Card>
            </Col>
          </Row>
        );

      case 2:
        return (
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Card size="small">
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                  <FileTextOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                  <strong>Domaine</strong>
                </div>
                {isViewMode ? (
                  <p>{data?.selectedCategorie}</p>
                ) : (
                  <Form.Item name="selectedCategorie">
                    <Select placeholder="Sélectionnez un domaine">
                      {categoriesOptions.map((category) => (
                        <Option key={category.value} value={category.value}>
                          {category.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card size="small">
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                  <CalendarOutlined style={{ marginRight: 8, color: '#722ed1' }} />
                  <strong>Date de création</strong>
                </div>
                <p>{data?.created ? new Date(data.created).toLocaleDateString() : 'N/A'}</p>
              </Card>
            </Col>
            {!isViewMode && (
              <>
                <Col xs={24} md={12}>
                  <Card size="small">
                    <strong style={{ display: 'block', marginBottom: 8 }}>Document</strong>
                    <Upload
                      beforeUpload={(file) => {
                        setDocument(file);
                        return false;
                      }}
                      maxCount={1}
                    >
                      <Button icon={<FileTextOutlined />}>Choisir un document</Button>
                    </Upload>
                  </Card>
                </Col>
                <Col xs={24} md={12}>
                  <Card size="small">
                    <strong style={{ display: 'block', marginBottom: 8 }}>Image</strong>
                    <Upload
                      beforeUpload={(file) => {
                        setImage(file);
                        return false;
                      }}
                      maxCount={1}
                      accept="image/*"
                    >
                      <Button icon={<FileTextOutlined />}>Choisir une image</Button>
                    </Upload>
                  </Card>
                </Col>
              </>
            )}
          </Row>
        );

      default:
        return null;
    }
  };

  return (
    <div>
      <Header />

      {/* Hero Section */}
      <div
        className="inner-hero bg-cover"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
          background: 'linear-gradient(135deg,rgb(165, 240, 161) 0%,rgb(101, 227, 42) 100%)',
          padding: '100px 0 60px 0'
        }}
      >
        <div className="container">
          <Row justify="center">
            <Col span={24} style={{ textAlign: 'center' }}>
              <h1 style={{
                color: 'white',
                fontSize: '2.5rem',
                fontWeight: 'bold',
                marginBottom: '20px',
                textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
              }}>
                Mes Publications
              </h1>
              <p style={{
                color: 'rgba(255,255,255,0.9)',
                fontSize: '1.1rem',
                textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
              }}>
                Gérez et suivez vos publications
              </p>
            </Col>
          </Row>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ padding: '60px 0', backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <Row gutter={[24, 24]}>
            {/* Profile Sidebar */}
            <Col xs={24} lg={6}>
              <Card
                style={{
                  textAlign: 'center',
                  borderRadius: '12px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}
              >
                <Avatar
                  size={100}
                  src={
                    currentUser && currentUser.photo
                      ? baseApiUrl.defaults.baseURL + `/image/${currentUser.photo}`
                      : "https://via.placeholder.com/100"
                  }
                  style={{ marginBottom: '16px' }}
                />
                <h3 style={{ marginBottom: '8px', color: '#1890ff' }}>
                  {currentUser?.nom} {currentUser?.prenom}
                </h3>
                <Tag color="blue" style={{ marginTop: '8px' }}>
                  {publications.length} Publication{publications.length > 1 ? 's' : ''}
                </Tag>
              </Card>
            </Col>

            {/* Publications Table */}
            <Col xs={24} lg={18}>
              <Card
                title={
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                      Mes Publications
                    </span>
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      style={{ borderRadius: '6px' }}
                    >
                      Nouvelle Publication
                    </Button>
                  </div>
                }
                style={{
                  borderRadius: '12px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}
              >
                <Table
                  rowKey="id"
                  columns={columns}
                  dataSource={publications}
                  pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} sur ${total} publications`,
                  }}
                  style={{
                    backgroundColor: 'white',
                    borderRadius: '8px'
                  }}
                />
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Edit Modal */}
      <Modal
        title={
          <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#1890ff' }}>
            <EditOutlined style={{ marginRight: '8px' }} />
            Modifier la publication
          </div>
        }
        visible={isEditModalVisible}
        onCancel={() => setIsEditModalVisible(false)}
        width={900}
        footer={null}
        style={{ borderRadius: '12px' }}
      >
        <Steps current={step} style={{ marginBottom: '32px' }}>
          <Step title="Informations de base" />
          <Step title="Impacts" />
          <Step title="Finalisation" />
        </Steps>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleEditPublication}
        >
          {renderStepContent(step)}

          <Divider />

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
              onClick={handlePrevious}
              disabled={step === 0}
            >
              Précédent
            </Button>

            <div>
              {step < 2 ? (
                <Button
                  type="primary"
                  onClick={handleNext}
                >
                  Suivant
                </Button>
              ) : (
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<CheckOutlined />}
                >
                  Modifier
                </Button>
              )}
            </div>
          </div>
        </Form>
      </Modal>

      {/* View Modal */}
      <Modal
        title={
          <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#1890ff' }}>
            <EyeOutlined style={{ marginRight: '8px' }} />
            Détails de la publication
          </div>
        }
        visible={isViewModalVisible}
        onCancel={() => setIsViewModalVisible(false)}
        width={900}
        footer={null}
        style={{ borderRadius: '12px' }}
      >
        <Steps current={step} style={{ marginBottom: '32px' }}>
          <Step title="Informations de base" />
          <Step title="Impacts" />
          <Step title="Détails supplémentaires" />
        </Steps>

        {renderStepContent(step, true)}

        <Divider />

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            onClick={handlePrevious}
            disabled={step === 0}
          >
            Précédent
          </Button>

          <Button
            type="primary"
            onClick={handleNext}
            disabled={step === 2}
          >
            Suivant
          </Button>
        </div>
      </Modal>

      <Footer1 />
      <Footer />
    </div>
  );
}

export default DetailPublications;
